import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card } from '@servicetitan/anvil2';
import { TitleValue } from './common/title-value';
import { CalculateSubCoolResponseDto } from '../../models/calculate-sub-cool.response.dto';
import { getFString } from '../../utils/get-f-string';
import classNames from 'classnames';

export const CalculateSubCoolAnswer: FC<{ data: CalculateSubCoolResponseDto; className?: string }> =
    observer(({ data, className }) => {
        return (
            <Card className={classNames('w-100-i', className)}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: 12 }}>
                    <TitleValue title="SubCool" value={getFString(data.sub_cool)} />
                    <TitleValue title="Bubble Temperature" value={getFString(data.bubble_temp)} />
                </div>
            </Card>
        );
    });
